import type { MailboxInfo } from "owa-client-types";
import { copilotSettingsStore, FetchState, type ImplementedCopilotFeatures, } from "owa-copilot-settings-store";
import { getLinkedLicensingMailboxInfoOrSelf } from "owa-session-store";
import isCopilotFeatureEnabled from "./isCopilotFeatureEnabled";

export default function isCopilotFeatureEnabledFromFreshSettings(scenario: ImplementedCopilotFeatures, mailboxInfo: MailboxInfo, skipLanguageCheck?: boolean, shouldIgnoreUserPreferences?: boolean): boolean {
    const settingsMailboxInfo = getLinkedLicensingMailboxInfoOrSelf(mailboxInfo);
    const isEnabled = isCopilotFeatureEnabled(scenario, settingsMailboxInfo, skipLanguageCheck, shouldIgnoreUserPreferences);
    
    return (copilotSettingsStore(settingsMailboxInfo).fetchState === FetchState.SUCCEEDED && !!isEnabled);
}
